// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"sr_a bhr_rc bhr_qx bhr_xr","ContestPosts__more":"sr_b bhr_vu bhr_b bhr_va bhr_sv"};